import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CURRENCIES_BY_HUB } from '../../../constants';
import * as authSelectors from '../../auth/selectors';
import { isAsicRegulator } from 'helpers/regulators';
import { HUB } from 'constants/hubs';

export const useCurrencies = (isPublic, regulator) => {
  const [currencies, setCurrencies] = useState([]);
  const userCurrencies = useSelector(authSelectors.getUserCurrencies);

  useEffect(() => {
    if (isPublic) {
      if (isAsicRegulator(regulator)) {
        return setCurrencies(CURRENCIES_BY_HUB[HUB.FUSION_MARKETS]);
      }
      return setCurrencies(CURRENCIES_BY_HUB[HUB.FUSION_MARKETS_X]);
    }

    setCurrencies(userCurrencies);
  }, [isPublic, regulator, userCurrencies]);

  return currencies;
};
